import { Button, Field, FieldError, FieldLabel, Input } from "@/components/ui";

import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import type { z } from "zod";

import { visitSearchFormSchema } from "./schemas";

interface VisitSearchFormProps {
  onSubmit(v: z.infer<typeof visitSearchFormSchema>): void;
  isLoading: boolean;
}

export const VisitSearchForm = ({
  onSubmit,
  isLoading,
}: VisitSearchFormProps) => {
  const form = useForm<z.infer<typeof visitSearchFormSchema>>({
    resolver: zodResolver(visitSearchFormSchema),
    mode: "onSubmit",
    defaultValues: {
      id: "",
    },
  });

  return (
    <form
      onSubmit={form.handleSubmit(onSubmit)}
      className="flex items-end gap-2 w-fit"
      data-testid="visit-search-form"
    >
      <Controller
        control={form.control}
        name="id"
        render={({ field, fieldState }) => (
          <Field data-invalid={fieldState.invalid}>
            <FieldLabel htmlFor="visitId">Visit ID</FieldLabel>
            <Input
              {...field}
              id="visitId"
              className="w-full"
              aria-invalid={fieldState.invalid}
            />
            <FieldError errors={[fieldState.error]} />
          </Field>
        )}
      />

      <Button
        type="submit"
        className="w-fit h-fit leading-tight"
        isLoading={isLoading}
      >
        Search
      </Button>
    </form>
  );
};
